module.exports = __webpack_public_path__ + "static/img/抖音广告_02.af98a98.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/gdd102/抖音广告_02.gif
// module id = gZKR
// module chunks = 1